import IndexPage from './page/index';

export default function App() {
  return <IndexPage />;
}
